import { FeePostApplyOffsetsTableContext } from "features/fees/post/apply-offsets/FeePostApplyOffsetsTableContext";
import { FundFamilyUseAllocationTableColumnDataFeeOffset } from "gen/model/fundFamilyUseAllocationTableColumnDataFeeOffset";
import { FundFamilyUseAllocationTableRow } from "gen/model/fundFamilyUseAllocationTableRow";
import { FundFamilyUseAllocationTableGetAllocationFn } from "shared/components/fund-family-use-allocation/FundFamilyUseAllocationTableProps";

export const getFundAllocationColumnData = (
  row: FundFamilyUseAllocationTableRow | undefined,
): FundFamilyUseAllocationTableColumnDataFeeOffset | undefined =>
  row?.column_data?.type === "fee_offset" ? row.column_data : undefined;

export const getFundAllocationForFeeOffsets: FundFamilyUseAllocationTableGetAllocationFn =
  ({ context, fundDef, row }) => {
    const allocationsByLookupKey = (
      context as unknown as FeePostApplyOffsetsTableContext
    ).getAllocationsByLookupKey;
    const transactionCodeId =
      getFundAllocationColumnData(row)?.transaction_code_id;
    if (!transactionCodeId) {
      return undefined;
    }
    const fundAllocations = allocationsByLookupKey?.({
      transaction_code_id: transactionCodeId,
      investment_id: null,
    });
    const fundInfo = fundAllocations?.find((it) => it.id === fundDef.fund_id);
    if (!fundInfo) {
      return undefined;
    }
    return {
      ownershipPercentage: fundInfo.ownershipPercentage,
      allocationRuleId: fundInfo.allocationRuleId,
      allocationRuleName: fundInfo.allocationRuleName,
    };
  };
